import { List } from "immutable";

export default {
  ADD(state, point) {
    state.points = state.points.push(point);
  },
  SET(state, points) {
    state.points = List(points);
  },
  CLEAR(state) {
    state.points = List();
    state.editMode = 0;
    state.plot = null;
  },
  SET_EDIT_MODE(state, mode) {
    state.editMode = mode;
  },
}
